export const OTC_BUSINESS_HOURS = Object.freeze({
    timeZone: "Africa/Lagos",
    weekdays: Object.freeze(["Mon", "Tue", "Wed", "Thu", "Fri"]),
    opensAt: 9,
    closesAt: 17,
});

export const isWithinOtcBusinessHours = (date = new Date()) => {
    const parts = new Intl.DateTimeFormat("en-US", {
        timeZone: OTC_BUSINESS_HOURS.timeZone,
        weekday: "short",
        hour: "2-digit",
        hourCycle: "h23",
    }).formatToParts(date);
    const weekday = parts.find((part) => part.type === "weekday")?.value;
    const hour = Number(parts.find((part) => part.type === "hour")?.value);

    return (
        OTC_BUSINESS_HOURS.weekdays.includes(weekday) &&
        hour >= OTC_BUSINESS_HOURS.opensAt &&
        hour < OTC_BUSINESS_HOURS.closesAt
    );
};
